export default "__VITE_ASSET__o8ujpH58__"